import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAdmin } from '../hooks/useIsAdmin';
import { useCurrentUser } from '../hooks/useCurrentUser';

export function AdminRoute({ children }: { children: ReactNode }) {
  const { isLoading } = useCurrentUser();
  const isAdmin = useIsAdmin();

  if (isLoading) return null;
  if (!isAdmin) return <Navigate to="/me" replace />;
  return <>{children}</>;
}
